import { render, staticRenderFns } from "./myMakeAnAppointment.vue?vue&type=template&id=015a6d90&scoped=true"
import script from "./myMakeAnAppointment.vue?vue&type=script&lang=js"
export * from "./myMakeAnAppointment.vue?vue&type=script&lang=js"
import style0 from "./myMakeAnAppointment.vue?vue&type=style&index=0&id=015a6d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a6d90",
  null
  
)

export default component.exports